import {
  ASYNC_START,
  ASYNC_END,
  USER_PAGE_LOADED,
  USER_PAGE_UNLOADED,
  USER_CREATE,
  USER_CREATE_UNLOADED,
  UPDATE_LOCK_STATUS,
  RESET_BANK_VERIFICATION,
  USER_ROLE_UPDATED,
  USER_TOGGLE_MFA,
  UPDATE_FIELD_USER,
  USER_REFERRER_UPDATED,
  RESEND_VERIFICATION_EMAIL,
  UPDATE_PHONE_STATUS,
  UPDATE_MERCHANT_FEE_RATE,
  UPDATE_PHONE,
  UPDATE_PIN,
} from '../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case USER_PAGE_LOADED:
      return {
        ...state,
        user: action.payload[0].user,
        accounts: action.payload[1].accounts,
        // tradeAnalysis: action.payload[2]
      };
    case USER_CREATE_UNLOADED:
    case USER_PAGE_UNLOADED:
      return {};
    case UPDATE_LOCK_STATUS:
    case UPDATE_PHONE_STATUS:
      return {
        ...state,
        user: action.payload.user
      };
    case USER_CREATE:
    case RESEND_VERIFICATION_EMAIL:
      return {
        ...state,
        inProgress: false,
        errors: action.error ? action.payload.error : null,
      };
    case RESET_BANK_VERIFICATION:
    case USER_ROLE_UPDATED:
    case USER_TOGGLE_MFA:
    case USER_REFERRER_UPDATED:
    case UPDATE_MERCHANT_FEE_RATE:
      return {
        ...state,
        errors: action.error ? action.payload.error : null,
        user: action.payload.user || state.user
      };
    case UPDATE_PHONE:
      return {
        ...state,
        errors: action.error ? action.payload.error : null,
        user: action.payload.user || state.user,
      };

    case UPDATE_PIN:
      return {
        ...state,
        errors: action.error ? action.payload.error : null,
        user: action.payload.user || state.user,
      };
    case ASYNC_START:
      let update_phone_inprogress, update_pin_inprogress = false
      if (action.subtype === UPDATE_PHONE) {
        update_phone_inprogress = true
      }
      if (action.subtype === UPDATE_PIN) {
        update_pin_inprogress = true
      }
      return {
        ...state,
        inProgress: false,
        update_phone_inprogress: update_phone_inprogress,
        update_pin_inprogress: update_pin_inprogress
      }
    case ASYNC_END:
      return {
        ...state,
        inProgress: false,
        update_phone_inprogress: false,
        update_pin_inprogress: false
      }
    case UPDATE_FIELD_USER:
      return { ...state, [action.key]: action.value };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/user.js